import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './index.styl';

export default function LayoutContent(props) {
  return (
    <div className={cx('layoutContent', styles.content)} data-qa='lb-content'>
      {props.children}
    </div>
  );
}

LayoutContent.propTypes = {
  children: PropTypes.node,
};
